module.exports = __webpack_public_path__ + "img/euro-logo.9c3deda2.svg";